// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76fda7e6","239":"5547fdcd","732":"b23ade9b"}[chunkId] + ".chunk.js";
};